<template>
  <yxtf-dialog
    ref="drawer"
    append-to-body
    :visible.sync="visible"
    width="640px"
    :cutline="false"
    padding-size="medium"
    custom-class="skill_detail-dialog"
  >
    <div class="eval-detail-wrap">
      <div class="standard-size-24 font-medium text-center mb16">
        {{ title || $t('pc_gwnl_web_capacityAssessmentDetails') }}
      </div>
      <yxt-scrollbar>
        <div class="eval-detail-content">
          <yxtf-tabs
            v-if="skill.family === 1"
            v-model="activeSkillId"
            class="gwnl-web-evaldetail-checkbox"
          >
            <yxtf-tab-pane
              v-for="(item) in skill[tabArrKey]"
              :key="item.skillId"
              :label="item.name"
              :name="item.skillId"
            />
          </yxtf-tabs>
          <tab-content
            :class="{ mt24: skill.family === 2 }"
            :active-skill-item="activeSkillItem"
            :show-skill-level="showSkillLevel"
          />
        </div>
      </yxt-scrollbar>
    </div>
  </yxtf-dialog>
</template>
<script>
import tabContent from './tabContent';

export default {
  components: {
    tabContent
  },
  provide() {
    return {
      showTag: this.showTag
    };
  },
  props: {
    skill: {
      type: Object,
      default: () => {}
    },
    tabArrKey: { // 二级分类数据key
      type: String,
      default: 'skills'
    },
    title: {
      type: String,
      default: ''
    },
    showSkillLevel: {
      type: Boolean,
      default: true
    },
    showTag: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      visible: false,
      activeSkillId: ''
    };
  },
  computed: {
    activeSkillItem() {
      const skills = this.skill || {};
      if (skills.family === 1) { // 二级分类
        return skills[this.tabArrKey] && skills[this.tabArrKey].find(item => item.skillId === this.activeSkillId) || {};
      } else {
        return skills || {};
      }
    }
  },
  methods: {
    show() {
      this.visible = true;
      if (this.skill.family === 1) this.activeSkillId = this.skill[this.tabArrKey] && this.skill[this.tabArrKey].length && this.skill[this.tabArrKey][0].skillId;
    },
    close() {
      this.$refs.drawer.closeDrawer();
    }
  }
};
</script>
<style lang="scss" scoped>
.yxtf-dialog__wrapper {
  ::v-deep .skill_detail-dialog {
    max-height: 851px;
  }
}

::v-deep .gwnl-web-evaldetail-checkbox {
  margin-right: -32px;
  margin-left: -24px;

  &.yxtf-tabs--bottom .yxtf-tabs__item.is-bottom:last-child,
  &.yxtf-tabs--bottom .yxtf-tabs__item.is-top:last-child,
  &.yxtf-tabs--top .yxtf-tabs__item.is-bottom:last-child,
  &.yxtf-tabs--top .yxtf-tabs__item.is-top:last-child {
    padding-right: 24px;
  }
}

.eval-detail-wrap {
  margin-right: 0;
  margin-left: 0;
}

.eval-detail-content {
  min-height: 180px;
  max-height: 550px;
  padding: 0 32px;
}
</style>
<style lang="scss">
.skill_detail-dialog {
  &.yxtf-dialog--medium .yxtf-dialog__body {
    padding-right: 0;
    padding-left: 0;
  }
}
</style>
